import { ApplicationApiTagTypes, ApplicationApiUrls } from "@/modules/application/common/enum";
import type {
  ICreateUserOpeningApplicationRequest,
  IUpdateUserOpeningApplicationRequest,
  IUserOpeningApplication
} from "@/modules/application/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const userOpeningApplicationApi = createApi({
  reducerPath: "userOpeningApplicationApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: [ApplicationApiTagTypes.ApplicationHistory],
  endpoints: (builder) => ({
    createUserOpeningApplication: builder.mutation<string, ICreateUserOpeningApplicationRequest>(
      withIdempotency<ICreateUserOpeningApplicationRequest>(
        ApplicationApiUrls.UserOpeningApplication,
      )),
    updateUserOpeningApplication: builder.mutation<string, IUpdateUserOpeningApplicationRequest>(
      {
        query: ({ data, id }) => ({
          url: `${ApplicationApiUrls.UserOpeningApplication}/${id}`,
          method: "PUT",
          data,
        }),
      }),
    getUserOpeningApplication: builder.query<IUserOpeningApplication, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${ApplicationApiUrls.UserOpeningApplication}/${id}`,
      }),
    }),
  }),
});

export const {
  useGetUserOpeningApplicationQuery,
  useCreateUserOpeningApplicationMutation,
  useUpdateUserOpeningApplicationMutation,
} = userOpeningApplicationApi;
